import { createSlice } from "@reduxjs/toolkit";
import { getState } from "@bd-stores/store";
import CONFIG from "@bd-core/config";

/**
 * @type {BD_StoreUserProgress}
 */
const initialState = {
    isFirebaseInitialized: false,
    currentPageId: undefined,
    currentPageType: undefined,
};

const userProgressSlice = createSlice({
    name: "userProgress",
    initialState,
    reducers: {
        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<typeof initialState['isFirebaseInitialized']>} action
         */
        setFirebaseInitialized: (state, action) => ({
            ...state,
            isFirebaseInitialized: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<typeof initialState['currentPageId']>} action
         */
        setCurrentPageId: (state, action) => ({
            ...state,
            currentPageId: action.payload,
        }),

        /**
         * @param {typeof initialState} state
         * @param {import("@reduxjs/toolkit").PayloadAction<typeof initialState['currentPageType']>} action
         */
        setCurrentPageType: (state, action) => ({
            ...state,
            currentPageType: action.payload,
        }),
    },
});

export const getCurrentPageId = () => {
    const pageId = getState().userProgress.currentPageId;
    return pageId ? pageId : CONFIG.game.mainrooms[0].id;
};

export const getCurrentPageType = () => {
    const pageType = getState().userProgress.currentPageType;
    return pageType ? pageType : "main-room";
};

export const currentPageIsMainRoom = () => {
    const currPageId = getCurrentPageId();
    const theMainRoom = CONFIG.game.mainrooms.find((r) => r.id == currPageId);
    return theMainRoom ? true : false;
};

export const { setFirebaseInitialized, setCurrentPageId, setCurrentPageType } =
    userProgressSlice.actions;
export const userProgress = userProgressSlice.reducer;
